import React from 'react';
import { Link } from 'react-router-dom';
import { TestTube, UserPlus, Building2, Mail, PartyPopper, Briefcase, User, MessageSquare, Inbox } from 'lucide-react';

const Testing: React.FC = () => {
  const testPages = [
    {
      name: 'Signup Choice',
      path: '/signup-choice',
      icon: <UserPlus className="w-6 h-6" />,
      description: 'Choose between Explorer and Recruiter signup',
      color: 'pink'
    },
    {
      name: 'Explorer Signup',
      path: '/signup',
      icon: <UserPlus className="w-6 h-6" />,
      description: 'Explorer (Job Seeker) signup flow',
      color: 'yellow'
    },
    {
      name: 'Recruiter Signup',
      path: '/recruiter-signup',
      icon: <Building2 className="w-6 h-6" />,
      description: 'Recruiter signup flow',
      color: 'pink'
    },
    {
      name: 'Email Confirmation',
      path: '/email-confirmation',
      icon: <Mail className="w-6 h-6" />,
      description: 'Email confirmation page',
      color: 'blue'
    },
    {
      name: 'Welcome Recruiter',
      path: '/welcome-recruiter',
      icon: <Briefcase className="w-6 h-6" />,
      description: 'Welcome page for new Recruiters',
      color: 'orange'
    },
    {
      name: 'Cevee Profile',
      path: '/profile',
      icon: <User className="w-6 h-6" />,
      description: 'Explorer profile page',
      color: 'blue'
    },
    {
      name: 'Recruiter Profile',
      path: '/recruiter-profile',
      icon: <Building2 className="w-6 h-6" />,
      description: 'Recruiter profile page',
      color: 'orange'
    },
    {
      name: 'Messages',
      path: '/messages',
      icon: <MessageSquare className="w-6 h-6" />,
      description: 'Explorer & Candidate inbox (messages)',
      color: 'purple'
    },
    {
      name: 'Recruiter Inbox',
      path: '/recruiter-inbox',
      icon: <Inbox className="w-6 h-6" />,
      description: 'Recruiter inbox with AI clustering',
      color: 'blue'
    }
  ];

  const getColorClasses = (color: string) => {
    const colors: Record<string, { bg: string; border: string; text: string; hover: string }> = {
      pink: {
        bg: 'bg-pink-50',
        border: 'border-pink-200',
        text: 'text-pink-600',
        hover: 'hover:border-pink-400 hover:shadow-pink-100'
      },
      yellow: {
        bg: 'bg-yellow-50',
        border: 'border-yellow-200',
        text: 'text-yellow-600',
        hover: 'hover:border-yellow-400 hover:shadow-yellow-100'
      },
      blue: {
        bg: 'bg-blue-50',
        border: 'border-blue-200',
        text: 'text-blue-600',
        hover: 'hover:border-blue-400 hover:shadow-blue-100'
      },
      green: {
        bg: 'bg-green-50',
        border: 'border-green-200',
        text: 'text-green-600',
        hover: 'hover:border-green-400 hover:shadow-green-100'
      },
      orange: {
        bg: 'bg-orange-50',
        border: 'border-orange-200',
        text: 'text-orange-600',
        hover: 'hover:border-orange-400 hover:shadow-orange-100'
      },
      purple: {
        bg: 'bg-purple-50',
        border: 'border-purple-200',
        text: 'text-purple-600',
        hover: 'hover:border-purple-400 hover:shadow-purple-100'
      }
    };
    return colors[color] || colors.blue;
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <TestTube className="w-12 h-12 text-purple-600" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Testing Hub
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Quick access to all testing pages for development and QA. Navigate to any page to test flows and features.
          </p>
        </div>

        {/* Testing Pages Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testPages.map((page) => {
            const colors = getColorClasses(page.color);
            return (
              <Link
                key={page.path}
                to={page.path}
                className={`block p-6 rounded-xl border-2 ${colors.border} ${colors.bg} ${colors.hover} transition-all duration-200 hover:shadow-lg`}
              >
                <div className={`${colors.text} mb-3`}>
                  {page.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {page.name}
                </h3>
                <p className="text-gray-600 text-sm">
                  {page.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Testing;

